import { Marker } from '@design-systems/canvas-ui'
import type { MarkerProps } from '@design-systems/canvas-ui'
import Icon, {
    ChartBarVerticalIcon,
    CompareIcon,
    TemplateIcon,
} from '@design-systems/react-icons'

export enum CategoryVariant {
    Performance = 'performance',
    Digital = 'digital',
    District = 'district',
}

export enum CategoryColor {
    Performance = 'green',
    Digital = 'pink',
    District = 'purple',
}

interface CategoryConfig {
    color: NonNullable<MarkerProps['color']>
    svg: typeof ChartBarVerticalIcon
}

const CATEGORY_CONFIG: Record<CategoryVariant, CategoryConfig> = {
    [CategoryVariant.Performance]: {
        color: CategoryColor.Performance,
        svg: ChartBarVerticalIcon,
    },
    [CategoryVariant.Digital]: {
        color: CategoryColor.Digital,
        svg: TemplateIcon,
    },
    [CategoryVariant.District]: {
        color: CategoryColor.District,
        svg: CompareIcon,
    },
}

export interface CategoryMarkerProps {
    variant: CategoryVariant
    label: string
}

export const CategoryMarker = ({ variant, label }: CategoryMarkerProps) => {
    const { color, svg } = CATEGORY_CONFIG[variant]

    return (
        <Marker color={color} leadingDecorator={<Icon svg={svg} size="sm" />}>
            {label}
        </Marker>
    )
}
